import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./index.css";
import withTranslation from "../../translation";

const cx = classnames.bind(this);

class CookieDisclaimer extends React.Component {
  static propTypes = {
    formatTranslation: PropTypes.func.isRequired,
    openCookieMessage: PropTypes.func.isRequired,
    closeCookieMessage: PropTypes.func.isRequired,
    cookieMessageOpen: PropTypes.bool.isRequired,
    isSidePanelOpen: PropTypes.bool.isRequired,
    defaultStoreUrl: PropTypes.string.isRequired
  };

  render() {
    const {
      formatTranslation,
      closeCookieMessage,
      cookieMessageOpen,
      isSidePanelOpen,
      defaultStoreUrl
    } = this.props;

    return (
      <div
        className={cx(styles.cookieDisclaimer, {
          [styles.visible]: !isSidePanelOpen && cookieMessageOpen
        })}
      >
        <div className={styles.container} data-testid="cookie-disclaimer">
          <p className={styles.summary}>
            {formatTranslation("CookieDisclaimer.summary")}
            <a
              className={styles.readMore}
              href={defaultStoreUrl.concat(
                formatTranslation("CookieDisclaimer.link")
              )}
            >
              {formatTranslation("CookieDisclaimer.readMore")}
            </a>
          </p>
          <button
            type="button"
            className={styles.closeButton}
            onClick={closeCookieMessage}
            data-testid="close-button"
          />
        </div>
      </div>
    );
  }
}

export default withTranslation(CookieDisclaimer);



// WEBPACK FOOTER //
// ./template/components/Header/CookieDisclaimer/CookieDisclaimer.js